import {IAngularStatic, IModule} from 'angular';
import {IFortyTwoStatic} from '@js/FortyTwoFramework';

export const ft: IFortyTwoStatic = window.ft;
export const ng: IAngularStatic = window.ng;

export const app: IModule = window.ft.app;